
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ReadyToStartSection from '../../components/feature/ReadyToStartSection';
import Button from '../../components/base/Button';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function About() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-[#FFF7E8] py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
              className={`text-center transition-all duration-600 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              <h1
                className="text-4xl md:text-5xl font-bold text-[#333333] mb-6"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                About Us - The Creative Way
              </h1>
              <p
                className="text-xl text-[#333333]/80 max-w-3xl mx-auto leading-relaxed"
                style={{ fontFamily: '"Open Sans", sans-serif' }}
              >
                Why Creative Journeys?
                At Creative Journeys, we believe early education should feel like an extension of home — warm, safe, and filled with joy. Our approach blends creativity, structure, and individualized care, helping each child grow socially, emotionally, and academically.
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Values */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Values Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center p-6 bg-[#FFF7E8] rounded-xl">
                <div className="w-16 h-16 flex items-center justify-center bg-[#A8D8F0] rounded-full mx-auto mb-4">
                  <i className="ri-heart-line text-2xl text-white"></i>
                </div>
                <h3
                  className="text-xl font-bold text-[#333333] mb-3"
                  style={{ fontFamily: '"Poppins", sans-serif' }}
                >
                  Nurturing Care
                </h3>
                <p
                  className="text-[#333333]/80"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Every child receives individualized attention and care in a loving, supportive environment.
                </p>
              </div>

              <div className="text-center p-6 bg-[#FFF7E8] rounded-xl">
                <div className="w-16 h-16 flex items-center justify-center bg-[#BFE6CC] rounded-full mx-auto mb-4">
                  <i className="ri-lightbulb-line text-2xl text-white"></i>
                </div>
                <h3
                  className="text-xl font-bold text-[#333333] mb-3"
                  style={{ fontFamily: '"Poppins", sans-serif' }}
                >
                  Creative Learning
                </h3>
                <p
                  className="text-[#333333]/80"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Play-based curriculum that sparks imagination and encourages creative expression.
                </p>
              </div>

              <div className="text-center p-6 bg-[#FFF7E8] rounded-xl">
                <div className="w-16 h-16 flex items-center justify-center bg-[#A8D8F0] rounded-full mx-auto mb-4">
                  <i className="ri-group-line text-2xl text-white"></i>
                </div>
                <h3
                  className="text-xl font-bold text-[#333333] mb-3"
                  style={{ fontFamily: '"Poppins", sans-serif' }}
                >
                  Community Focus
                </h3>
                <p
                  className="text-[#333333]/80"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Building strong partnerships with families and fostering a sense of belonging.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Our Story */}
        <section className="py-16 bg-[#FFF7E8]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2
                className="text-3xl font-bold text-[#333333] mb-6"
                style={{ fontFamily: '"Poppins", sans-serif' }}
              >
                Our Story
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <img
                  src="https://public.readdy.ai/ai/img_res/ab63bdb25c9de02f49a2a7e49abf79d1.jpg"
                  alt="The Johnson Family - Founders"
                  className="w-full h-96 object-cover object-top rounded-xl shadow-lg"
                />
              </div>
              <div>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed mb-6"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Our mission is to create a child-centered environment where all are encouraged to impact their world… One Step At A Time.
                </p>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed mb-6"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Creative Journeys Learning Center was founded in 2005 as local mother and daughter owners recognized the need for high-quality, family-centered childcare in our community. With backgrounds in early childhood education and child development, they set out to create a place where children could thrive.
                </p>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed mb-6"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Focused on the belief that strong families build strong communities, we partner closely with parents and caregivers to support every child's unique developmental journey. Our caring teachers create a warm and engaging environment that promotes learning through play, creativity, and discovery.
                </p>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed mb-6"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  We offer age-appropriate programs designed to support every stage of early childhood-- from infants and toddlers to preschools and pre-kindergarten learners. Each day, our classrooms are filled with laughter, curiosity, and opportunities to build confidence, social skills and a lifelong love of learning.
                </p>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed mb-6"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  At Creative Journeys Learning Center, family is at the heart of everything we do. We're more than just a childcare center, we're a community where children grow, families connect, and lasting memories are made.
                </p>
                <p
                  className="text-lg text-[#333333]/80 leading-relaxed"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  Today, our dedicated team of educators continues to uphold our mission values to create a special place where every child feels valued, supported, and excited to learn.
                </p>
              </div>
            </div>
          </div>
        </section>

        <ReadyToStartSection />
      </main>
      <Footer />
    </div>
  );
}
